import {
  Component, ComponentFactory, NgModule, Input, Injectable, Injector, Compiler,
  ReflectiveInjector, ComponentFactoryResolver, ViewContainerRef, CUSTOM_ELEMENTS_SCHEMA, ComponentRef
} from '@angular/core';
import { COMPILER_PROVIDERS }  from '@angular/compiler';
import { AppModule } from "../../app.module";

import * as _ from "lodash";
import {ShareButtonsDirective} from "../directives/article/directives/share-buttons.directive";
import {HrefDirective} from "../directives/article/directives/href.directive";
import {ArticleDirectivesModule} from "../directives/article/articledirectives.module";

export interface IHaveDynamicData {

}

@Injectable()
export class DynamicTypeBuilder {

  private injector: Injector;
  private compiler: Compiler;

  constructor(protected compResolver:ComponentFactoryResolver,
              injector: Injector) {
    this.injector = ReflectiveInjector.resolveAndCreate(COMPILER_PROVIDERS, injector);
    this.compiler = this.injector.get(Compiler);
  }

  public createComponent(template: string, viewContainerRef: ViewContainerRef): Promise<ComponentRef<IHaveDynamicData>> {

    let component = this.createNewComponent(template);
    let module = this.createComponentModule(component);

    return new Promise((resolve) => {
      this.compiler.compileModuleAndAllComponentsAsync(module)
        .then(({componentFactories}) => {
          const componentFactory = componentFactories.find(x => x.componentType === component);
          viewContainerRef.clear();
          let componentRef = viewContainerRef.createComponent(componentFactory);

          resolve(componentRef);
        })
    });
  }

  protected createNewComponent(template:string) {
    return Component({
      selector: 'content',
      template
    })(class ContentComponent implements IHaveDynamicData {});
  }

  protected createComponentModule (componentType: any) {
    return NgModule({
      imports: [
        ArticleDirectivesModule,
      ],
      declarations: [
        componentType,
      ],
      schemas:[CUSTOM_ELEMENTS_SCHEMA]
    })(class RuntimeComponentModule {});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/type-builder/type.builder.ts